import DefaultHeader from "../../../shared/DefaultHeader";

const UserDashboard = () => {
  return (
    <>
      <DefaultHeader/>
      <div className="font-semibold text-lg xls:text-sm xl:text-3xl text-primary text-right xls:text-left">Dashboard</div>
    </> 
);
};
export default UserDashboard;
